import { AgentCommon } from '~/agents/common/common/agent'

export const SocialMediaManagerAgentCommon: AgentCommon = {
  key: 'socialMediaManager',
  hasOnboarding: true,
  hasSettings: true,
  guidelines: [
    {
      label: 'Writing Style',
      tag: 'content',
      suggestions: [
        `Start with a compelling hook to grab attention`,
        `Keep messages concise and clear`,
        `Incorporate relevant hashtags to increase reach`,
        `Include a clear call-to-action in each post`,
        `Engage with our audience by asking questions`,
        `Use emojis to convey tone and emotion`,
        `Tailor content to each specific platform's audience`,
        `Share user-generated content to build community`,
        `Utilize storytelling to connect with the audience`,
        `Highlight benefits over features`,
        `Use bullet points or numbered lists for readability`,
        `Avoid jargon; keep language accessible`,
        `End each post with an open-ended question to spark conversation and encourage comments`,
      ],
    },
    {
      label: 'Image Style',
      tag: 'image',
      suggestions: [
        'Ensure text overlays are legible on all devices',
        'Use images that are relevant to the accompanying text',
        `Ensure images are culturally sensitive and inclusive`,
        `Highlight products or services in use`,
        `Use images to tell a story or convey a message`,
        `Use images that evoke emotion or action`,
        `Keep designs uncluttered and focused`,
        'Keep visual hierarchy clear',
        `Don't crowd multiple elements into one image`,
      ],
    },
  ],
}
